<template>
  <v-container>
    <v-alert
      v-model="isError"
      dismissible
      type="error"
      transition="fade-transition"
    >
      {{ errMessage }}
    </v-alert>
    <h1>Devotionals and Sets</h1>
    <h2>Current Devotional</h2>
    <p>
      <span v-if="currentSetTitle">{{ currentSetTitle }} - Devotional #{{ currentDevoIndex }} ({{ currentDevoPassage }})</span>
      <span v-else>None</span>
      <v-icon small @click="editItem(null, 'marker')">edit</v-icon>
      <v-icon small @click="deleteMarker()">delete_forever</v-icon>
    </p>
    <h2>Devotional Sets</h2>
    <v-btn to="/admin/devotionals/sets/new">Add</v-btn>
    <v-data-table
      :headers="setHeaders"
      :items="sets"
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.index }}</td>
        <td>{{ (props.item.isFixed) ? 'Yes' : 'No' }}</td>
        <td>{{ props.item.title }}</td>
        <td>
          <v-icon
            small
            @click="editItem(props.item, 'set')"
          >edit
          </v-icon>
          <v-icon
            small
            @click="deleteItem(props.item, 'set')"
          >delete_forever
          </v-icon>
        </td>
      </template>
    </v-data-table>
    <h2>Devotionals</h2>
    <v-btn to="/admin/devotionals/new">Add</v-btn>
    <v-data-table
      :headers="devotionalHeaders"
      :items="devotionals"
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.setTitle }}</td>
        <td>{{ props.item.index }}</td>
        <td>{{ props.item.passage }}</td>
        <td><a :href="props.item.videoURL">View Here</a></td>
        <td>
          <v-icon
            small
            @click="editItem(props.item, 'devotional')"
          >edit
          </v-icon>
          <v-icon
            small
            @click="deleteItem(props.item, 'devotional')"
          >delete_forever
          </v-icon>
        </td>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    isError: false,
    errMessage: null,
    sets: [],
    setHeaders: [
      { text: '#', value: 'index' },
      { text: 'Always Available?', value: 'isFixed' },
      { text: 'Title', value: 'title' },
      { text: 'Actions', value: 'index' } // no actual value
    ],
    devotionals: [],
    devotionalHeaders: [
      { text: 'Set', value: 'setTitle' },
      { text: '#', value: 'index' },
      { text: 'Passage', value: 'passage' },
      { text: 'Video', value: 'videoURL' },
      { text: 'Actions', value: 'setTitle' } // no actual value
    ],
    currentSetTitle: null,
    currentDevoIndex: null,
    currentDevoPassage: null
  }),
  mounted: function () {
    var _this = this
    this.axios.get('/devotionals/sets')
      // Get set information
      .then(function (res) {
        _this.sets = res.data

        // Now get devotional information
        _this.axios.get('/devotionals')
          .then(function (res) {
            // Get a mapping of set IDs to set titles
            let map = {}
            for (let i in _this.sets) {
              let set = _this.sets[i]
              map[set.id] = set.title
            }

            // Add the setTitle attribute to each of our returned devotionals
            for (let i in res.data) {
              res.data[i].setTitle = map[res.data[i].setID]
            }

            // Now store our updated data as our devotionals
            _this.devotionals = res.data

            // Now get marker information
            _this.axios.get('/devotionals/marker')
              .then(function (res) {
                if (res.data) {
                  // Go through our sets to find a title
                  for (let i in _this.sets) {
                    if (_this.sets[i].index === res.data.setIndex) {
                      _this.currentSetTitle = _this.sets[i].title
                      break
                    }
                  }

                  // Go through our devotionals to find a passage
                  for (let i in _this.devotionals) {
                    if (_this.devotionals[i].setID === res.data.setID &&
                        _this.devotionals[i].index === res.data.devoIndex) {
                      _this.currentDevoPassage = _this.devotionals[i].passage
                    }
                  }

                  // Set our devotional index
                  _this.currentDevoIndex = res.data.devoIndex
                }
              })
              .catch(_this.$root.apiErrorHandler())
          })
          .catch(_this.$root.apiErrorHandler())
      })
      .catch(this.$root.apiErrorHandler())
  },
  methods: {
    editItem: function (item, type) {
      let url = null
      switch (type) {
        case 'devotional':
          url = '/admin/devotionals/' + item.id
          break
        case 'set':
          url = '/admin/devotionals/sets/' + item.id
          break
        case 'marker':
          url = '/admin/devotionals/marker'
          break
        default:
          return
      }

      this.$router.push(url)
    },
    deleteItem: function (item, type) {
      // Determine our request details based on arguments
      let url = '/devotionals'
      if (type === 'set') {
        url += '/sets'
      }
      url += '/' + item.id

      // Confirm with the user that they want to perform the requested action
      // before actually making the request
      var _this = this
      confirm('Do you want to remove this item?') &&
      this.axios.delete(url)
        .then(function (res) {
          let list = _this.devotionals
          if (type === 'set') {
            list = _this.sets
          }

          // Find the index of our item in its list
          var index = null
          for (var i in list) {
            if (list[i].id === item.id) {
              index = i
              break
            }
          }
          if (index !== null) {
            // Remove the proper row from the list
            list.splice(index, 1)
          } else {
            _this.errMessage = 'An error occurred. Please try again.'
            _this.isError = true
          }
        })
        .catch(this.$root.apiErrorHandler(function (msg) {
          _this.errMessage = msg
          _this.isError = true
        }))
    },
    deleteMarker: function () {
      let _this = this
      confirm('Do you want to clear the devotional marker? It will re-create itself on its own, so it is normally better to edit it.') &&
      this.axios.delete('/devotionals/marker')
        .then(function (res) {
          _this.currentSetTitle = null
          _this.currentDevoIndex = null
          _this.currentDevoPassage = null
        })
        .catch(this.$root.apiErrorHandler(function (msg) {
          _this.errMessage = msg
          _this.isError = true
        }))
    }
  }
}
</script>
